require("./graphic");

var _zrender = require("../zrender");

var registerPainter = _zrender.registerPainter;

var Painter = require("./Painter");

registerPainter('vml', Painter);


//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/vml/vml.js
// module id = 1945
// module chunks = 17